import React, { useState } from 'react';
import './loading-dots.css';
import { useDarkMode } from '../DarkModeContext';
import styles from './Settings.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import ProfilCard from './ProfilCard';
import PreferinteCard from './PreferinteCard';
import SchimbareParolaCard from './SchimbareParolaCard';
import DetaliiPlanCard from './DetaliiPlanCard';
import InchidereContCard from './InchidereContCard';
import AsistentaCard from './AsistentaCard';
import SettingsTabMenu from './SettingsTabMenu';
import { redirectToLogin } from '../utils/authRedirect';

import '../content/functionalpagelogin/SidebarMenuItems/reglaredimensiune.css';	

const TABS = [
	{ key: 'profil', label: 'Profil' },
	{ key: 'preferinte', label: 'Preferinte' },
	{ key: 'plan', label: 'Detalii plan' },
];


const apiUrl = process.env.REACT_APP_API_URL;

const Settings = ({ activeTab, setActiveTab }) => {
 const [userData, setUserData] = useState(null);
 const [loading, setLoading] = useState(true);
 const [selectedFile, setSelectedFile] = useState(null);
 const [previewImage, setPreviewImage] = useState(null);
 const [successMessage, setSuccessMessage] = useState('');
 const [soundEffects, setSoundEffects] = useState(true);
 const [currentPassword, setCurrentPassword] = useState('');
 const [newPassword, setNewPassword] = useState('');
 const [confirmPassword, setConfirmPassword] = useState('');
 const [showCurrentPassword, setShowCurrentPassword] = useState(false);
 const [showNewPassword, setShowNewPassword] = useState(false);
 const [passwordError, setPasswordError] = useState('');
 const [passwordSuccess, setPasswordSuccess] = useState('');
 const [hasPassword, setHasPassword] = useState(true);
 const { darkMode, setDarkMode } = useDarkMode();

 // Fetch user data from server (logic adapted from Setari.jsx)
 React.useEffect(() => {
		const fetchUserData = async () => {
			try {
				const response = await fetch(`${apiUrl}/user`, {
					method: 'GET',
					credentials: 'include',
				});
				if (response.ok) {
					const data = await response.json();
					setUserData(data);
					setHasPassword(data.has_password !== false);

if (typeof data.dark_mode === 'boolean') {
  setDarkMode(data.dark_mode); // sincronizează cu valoarea din backend
}

					// setDarkMode vine din context, deci nu mai e nevoie să-l setăm aici
				} else {
					setUserData({
						username: 'Vizitator',
						email: '',
						profile_picture: '',
						account_type: 'free',
						is_active: false
					});
				}
			} catch (err) {
				setUserData({
					username: 'Vizitator',
					email: '',
					profile_picture: '',
					account_type: 'free',
					is_active: false
				});
			} finally {
				setLoading(false);
			}
		};
		fetchUserData();
	}, []);

	// Dummy handlers
	const handleFileChange = () => {};
	const uploadProfilePicture = () => {};
	const onProfilePictureDelete = () => {};
	const onProfileSave = e => { e.preventDefault(); };
	const handleDarkModeToggle = async () => {
  const newMode = !darkMode;
  setDarkMode(newMode); // actualizează local tema

  try {
    const response = await fetch(`${apiUrl}/user/theme`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // pentru a trimite cookie-ul JWT
      body: JSON.stringify({ dark_mode: newMode }),
    });

    if (!response.ok) {
      throw new Error('Eroare la salvarea preferinței de temă');
    }

    console.log('✔️ Tema a fost actualizată pe server:', newMode);
  } catch (error) {
    console.error('❌ Eroare la trimiterea preferinței:', error);
  }
};

	const handleSoundEffectsToggle = () => setSoundEffects(s => !s);
	const handleChangePassword = e => { e.preventDefault(); setPasswordSuccess('Parola schimbată!'); setPasswordError(''); };
	const handleDeleteAccount = () => { alert('Cont șters!'); };

	 // activeTab și setActiveTab vin din props

	// Responsive: pe mobil afișezi doar cardul selectat cu buton Înapoi, fără meniu
	const [showCardMobile, setShowCardMobile] = useState(false); // false: vezi lista, true: vezi cardul
	const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
	const isMobile = windowWidth <= 1100;

	React.useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// Pe mobil: click pe tab => vezi cardul, click pe Înapoi => vezi lista
	 const handleTabClick = (key) => {
		 setActiveTab(key);
		 if (isMobile) setShowCardMobile(true);
	 };
	const handleBackMobile = () => setShowCardMobile(false);

	if (loading) return (
	  <div className="welcome-screen-lesson">
	    <div className="loading-dots">
	      <span></span>
	      <span></span>
	      <span></span>
	    </div>
	  </div>
	);

	return (
		<div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank"></div>
			
			{/* Breadcrumb și titlu ca în About.jsx, doar pe desktop */}
			{/* Desktop: doar conținutul tabului activ, fără meniu */}
			{!isMobile && (
				<div className={styles.settingsContainer}>
					<div className={styles.tabContent}>
						{activeTab === 'profil' && (
							<ProfilCard
								userData={userData}
								onProfilePictureChange={handleFileChange}
								onProfilePictureDelete={onProfilePictureDelete}
								onProfileSave={onProfileSave}
								selectedFile={selectedFile}
								previewImage={previewImage}
								successMessage={successMessage}
								handleFileChange={handleFileChange}
								uploadProfilePicture={uploadProfilePicture}
							/>
						)}
						{activeTab === 'preferinte' && (
							<PreferinteCard
								darkMode={darkMode}
								soundEffects={soundEffects}
								handleDarkModeToggle={handleDarkModeToggle}
								handleSoundEffectsToggle={handleSoundEffectsToggle}
							/>
						)}
						{activeTab === 'plan' && <DetaliiPlanCard plan={{
							name: userData?.plan_name || 'PERSONAL',
							startDate: userData?.plan_start || '01/12/2024',
							endDate: userData?.plan_end || '01/12/2025',
							nextBilling: userData?.plan_next_billing || '02/12/2024',
							paymentMethod: userData?.plan_payment_method || 'Card •••• 1234',
						}} />}
						{/* Buton de Deconectare */}
						<button
							className={styles.logoutButton}
							onClick={() => {
								fetch(`${apiUrl}/logout`, { method: 'POST', credentials: 'include' })
									.then(() => redirectToLogin());
							}}
						>
							<FontAwesomeIcon icon="fa-right-from-bracket" className={styles.logoutIcon} />
							Logout
						</button>
					</div>
				</div>
			)}
			{/* Mobil: overlay/modal peste tot */}
			{isMobile && (
				<div className={styles.mobileOverlay}>
					{!showCardMobile ? (
						<div className={styles.mobileMenuCard}>
							<div className={styles.mobileMenuHeader}>
								<span className={styles.mobBackIcon} onClick={() => window.history.back()}>
									<FontAwesomeIcon icon={faChevronLeft} />
								</span>
								<span className={styles.mobileMenuTitle} style={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>Setari</span>
								{/* Eliminat butonul verde 'Gata' */}
							</div>
							<div className={styles.mobileMenuListRows}>
								{TABS.map(tab => (
									<div key={tab.key} className={styles.mobileMenuRowCard}>
										<button
											className={styles.mobileMenuRowInner}
											onClick={() => handleTabClick(tab.key)}
										>
											<span>{tab.label}</span>
											<span className={styles.mobileMenuArrow}>&#8250;</span>
										</button>
									</div>
								))}
								{/* Buton Deconectare mobil */}
								<div className={styles.mobileMenuRowCard}>
									<button
										className={styles.mobileMenuRowInner}
										onClick={() => {
											fetch(`${apiUrl}/logout`, { method: 'POST', credentials: 'include' })
												.then(() => redirectToLogin());
										}}
									>
										<FontAwesomeIcon icon="fa-right-from-bracket" className={styles.logoutIcon} />
										Deconectare
									</button>
								</div>
							</div>
						</div>
					) : (
						<div className={styles.mobSectionCard}>
							<div className={styles.mobSectionHeader}>
								<span className={styles.mobBackIcon} onClick={handleBackMobile}>
									<FontAwesomeIcon icon={faChevronLeft} />
								</span>
								<div className={styles.mobSectionTitle}>{TABS.find(t => t.key === activeTab)?.label}</div>
								
							</div>
							<div className={styles.mobSectionContent}>
								<div className={styles.mobSectionInner}>
									{activeTab === 'profil' && (
										<ProfilCard
											userData={userData}
											onProfilePictureChange={handleFileChange}
											onProfilePictureDelete={onProfilePictureDelete}
											onProfileSave={onProfileSave}
											selectedFile={selectedFile}
											previewImage={previewImage}
											successMessage={successMessage}
											handleFileChange={handleFileChange}
											uploadProfilePicture={uploadProfilePicture}
										/>
									)}
									{activeTab === 'preferinte' && (
										<PreferinteCard
											darkMode={darkMode}
											soundEffects={soundEffects}
											handleDarkModeToggle={handleDarkModeToggle}
											handleSoundEffectsToggle={handleSoundEffectsToggle}
										/>
									)}
									{activeTab === 'plan' && <DetaliiPlanCard plan={{
										name: userData?.plan_name || 'PERSONAL',
										startDate: userData?.plan_start || '01/12/2024',
										endDate: userData?.plan_end || '01/12/2025',
										nextBilling: userData?.plan_next_billing || '02/12/2024',
										paymentMethod: userData?.plan_payment_method || 'Card •••• 1234',
									}} />}
								</div>
							</div>
						</div>
					)}
				</div>
			)}

<div className="right-elements-componentsmenu-settins">
				<SettingsTabMenu activeTab={activeTab} onTabClick={setActiveTab} />
			</div>

		</div>
	);
};

export default Settings;
